export default {
  delete: 'Delete',
  makePublic: 'Make public',
  makePrivate: 'Make private',
  save: 'Save',
  saved: 'User interface element saved',
  addField: 'Add field',
  addFilter: 'Add filter',
  addButton: 'Add button',
  fields: 'Fields',
  filters: 'Filters',
  buttons: 'Buttons',
  field: 'Field',
  filter: 'Filter',
  button: 'Button'
}
